(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const scroller = document.querySelector('.scroller');
    if (scroller) {
      scroller.style.maxWidth = window.innerWidth + 'px';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.testimonial-swiper', {
      loop: true,
      centeredSlides: true,
      slidesPerView: 1,
      spaceBetween: 30,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          centeredSlides: true,
        },
        768: {
          slidesPerView: 2,
          centeredSlides: true,
        },
        1024: {
          slidesPerView: 3,
          centeredSlides: true,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-catalogue"] && !Shopify.designMode) return;
  try {
    
  const mySwiper = new Swiper('.swiper-container', {
    slidesPerView: 3,
    slidesPerColumn: 3,
    slidesPerGroup: 3,
    spaceBetween: 30,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    on: {
      init: function () {},
      orientationchange: function () {},
      beforeResize: function () {
        let vw = window.innerWidth;
        if (vw > 768) {
          mySwiper.params.slidesPerView = 3;
          mySwiper.params.slidesPerColumn = 3;
          mySwiper.params.slidesPerGroup = 3;
        } else {
          mySwiper.params.slidesPerView = 4;
          mySwiper.params.slidesPerColumn = 2;
          mySwiper.params.slidesPerGroup = 4;
        }
        mySwiper.init();
      },
    },
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-description-tabs"] && !Shopify.designMode) return;
  try {
    
  // Mobile toggle
  document.querySelectorAll('.mobile-tab-button').forEach((button) => {
    button.addEventListener('click', () => {
      const tab = button.getAttribute('data-tab');
      const content = document.getElementById(tab);
      const isActive = button.classList.contains('active');

      // Close all tabs
      document.querySelectorAll('.mobile-tab-button').forEach((btn) => {
        btn.classList.remove('active');
        const icon = btn.querySelector('.icon');
        if (icon) icon.textContent = '+';
      });
      document.querySelectorAll('.mobile-tab-content').forEach((c) => {
        c.classList.remove('active');
      });

      // Toggle behavior: if it was not active, open it
      if (!isActive) {
        button.classList.add('active');
        const icon = button.querySelector('.icon');
        if (icon) icon.textContent = '-';
        content.classList.add('active');

        // Optional: Refresh Judge.me widget if this is the reviews tab
        if (tab === 'reviews' && window.judgeme) {
          setTimeout(() => {
            window.judgeme.refreshWidgets();
          }, 300);
        }
      }
    });
  });

  // Desktop tab switch (standard switch, not toggle)
  document.querySelectorAll('.tab-button').forEach((button) => {
    button.addEventListener('click', () => {
      const tab = button.getAttribute('data-tab');

      // Remove 'active' from all buttons and their <a> tags
      document.querySelectorAll('.tab-button').forEach((btn) => btn.classList.remove('active'));
      document.querySelectorAll('.tab-button a').forEach((a) => a.classList.remove('active'));

      // Add 'active' to clicked tab and its link
      button.classList.add('active');
      const anchor = button.querySelector('a');
      if (anchor) anchor.classList.add('active');

      // Switch tab content
      document.querySelectorAll('.tab-pane').forEach((pane) => pane.classList.remove('active'));
      const targetPane = document.getElementById(tab + '-desktop');
      if (targetPane) targetPane.classList.add('active');

      // Optional: Refresh Judge.me widget
      if (tab === 'reviews' && window.judgeme) {
        setTimeout(() => {
          window.judgeme.refreshWidgets();
        }, 300);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-buy-this-section"] && !Shopify.designMode) return;
  try {
     
  const cards = document.querySelectorAll('.feature-item');
  const totalCards = cards.length;
  const cardsPerRow = 3;
  const totalRows = Math.ceil(totalCards / cardsPerRow);
  const lastRowStartIndex = (totalRows - 1) * cardsPerRow;

  for (let i = lastRowStartIndex; i < totalCards; i++) {
    cards[i].style.borderBottom = 'none';
  }

  } catch(e) { console.error(e); }
})();
})();
